import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-loa-ui-law-section-status',
  templateUrl: './loa-ui-law-section-status.component.html',
  styleUrls: ['./loa-ui-law-section-status.component.scss'],
  standalone: true,
  imports: [CommonModule, TranslateModule],
})
export class LoaUiLawSectionStatusComponent {
  @Input() lawSection: string;
  @Input() certStatusSec26: string;
  @Input() certStatusSec28: string;
}
